import React from 'react';
import { Checkbox } from 'src/components/';
export interface ColumnMenuItemProps {
  field: string;
  headerName: string;
  isVisible: boolean;
  onChange: (field: string) => void;
  id?: string;
}

export const ColumnMenuItem: React.FC<ColumnMenuItemProps> = ({
  field,
  headerName,
  isVisible,
  onChange,
  id,
}) => {
  return (
    <button
      id={id}
      data-testid={id}
      className="w-full text-left px-4 py-2 text-sm font-medium hover:bg-gray-100 focus:outline-none focus:none flex items-center gap-2"
      onClick={() => onChange(field)}
      role="menuitemcheckbox"
      aria-checked={isVisible}
      aria-label={`${isVisible ? 'Hide' : 'Show'} ${headerName} column`}
    >
      <div className="relative inline-flex items-center">
        <Checkbox
          size="sm"
          variant="outlined"
          color="neutral"
          checked={isVisible}
          onChange={() => onChange(field)}
          data-testid={`${id}-checkbox`}
          aria-hidden="true"
        />
      </div>
      <span>{headerName}</span>
    </button>
  );
};

export default ColumnMenuItem;
